import React from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../../components/admin/AdminLayout';

function AdminSiteContactHome() {
  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Contact</h1>
      <p>Gérez les informations de contact et les messages reçus.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px,1fr))', gap: 16, marginTop: 16 }}>
        <div className="card">
          <h3>Réglages</h3>
          <p>Coordonnées, horaires, liens sociaux.</p>
          <Link to="/admin/site/contact/reglages">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Messages</h3>
          <p>Boîte de réception du formulaire de contact.</p>
          <Link to="/admin/site/contact/messages">Ouvrir</Link>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminSiteContactHome;
